const currencyFormatter = (
  price: number | string | undefined | null,
  countryCode: string
) => {
  if (!price) return;
  return price.toLocaleString(`en-${countryCode}`, {
    style: "currency",
    currency: countryCode === "US" ? "USD" : "CAD",
  });
};

export const bigDollarSmallCentsFormatter = (
  price: number | string | undefined | null,
  countryCode: string
) => {
  if (!price) return;
  const result = currencyFormatter(price, countryCode);
  if (typeof result === "undefined") {
    return;
  }
  const formattedPrice = result.toString();
  const cents = formattedPrice.split(".").pop();
  const dollar = formattedPrice.slice(1, formattedPrice.indexOf("."));
  return [dollar, cents];
};

export const centsToDollars = (num: number | string) =>
  typeof num === "number" ? num / 100 : num;

export const formatCurrency = (
  price: number | string | null,
  countryCode: string
) => {
  if (!price) {
    return;
  }

  const amount = currencyFormatter(price, countryCode);
  const [dollars, cents] =
    bigDollarSmallCentsFormatter(price, countryCode) || [];
  const symbol = amount?.slice(0, 1);

  return {
    formattedPrice: amount,
    cents,
    dollars,
    symbol,
  };
};

export default currencyFormatter;
